import { render, staticRenderFns } from "./Ppbkl.vue?vue&type=template&id=4e2033d1"
import script from "./Ppbkl.vue?vue&type=script&lang=js"
export * from "./Ppbkl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports